import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'

// Components
import Button from '@/components/common/livemallclub/Button'

// Libs
import { useFollowingActions } from '@/hooks/livemallclub/useFollow'

// Styles
import styles from './style.module.scss'
import { USER_ROLE } from '@/types/user-profile'

// Variables

// PropTypes

type FollowActionButtonProps = {
  className?: string
  memberInfoId: string
  mutationCallBack?: () => void
  isFollowing?: boolean
  allowFollow?: boolean
  isThemChangeByState?: boolean
  followerType: USER_ROLE
  followeeType: USER_ROLE
}
const cx = classnames.bind(styles)

const FollowActionButton = (props: FollowActionButtonProps) => {
  const {
    memberInfoId,
    allowFollow = true,
    isFollowing,
    mutationCallBack = () => {},
    className,
    isThemChangeByState = true,
    followeeType,
    followerType,
  } = props
  const [isFollowingState, setIsFollowingState] = useState(isFollowing)

  const { handleAddFollowingMember, handleUnFollowMember } = useFollowingActions({
    followeeId: memberInfoId,
    mutationCallback: mutationCallBack,
    followeeType,
    followerType,
  })

  const { t } = useTranslation()
  const handleFollowButtonClick = () => {
    if (!memberInfoId) return
    if (isFollowingState) {
      handleUnFollowMember({
        followeeId: memberInfoId,
      })
    } else {
      handleAddFollowingMember({
        followeeId: memberInfoId,
      })
    }
    setIsFollowingState(!isFollowingState)
  }
  const theme = isThemChangeByState ? (isFollowingState ? 'white' : 'pink') : 'white'
  const text = isFollowingState ? t('Common_Following') : t('Common_Follow')
  return (
    <>
      {allowFollow && (
        <Button theme={theme} onClick={handleFollowButtonClick} className={cx('button', className)}>
          {text}
        </Button>
      )}
    </>
  )
}

export default FollowActionButton
